/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Drop_FilesInputs */

const es_chat_drop_files = /** @type {(inputs: Chat_Drop_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastrá tus archivos aquí para adjuntarlos.`)
};

const en_chat_drop_files = /** @type {(inputs: Chat_Drop_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop your files here to attach them.`)
};

/**
* | output |
* | --- |
* | "Drop your files here to attach them." |
*
* @param {Chat_Drop_FilesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_drop_files = /** @type {((inputs?: Chat_Drop_FilesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Drop_FilesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_drop_files(inputs)
	return en_chat_drop_files(inputs)
});
export { chat_drop_files as "chat.drop_files" }